import { type LinkProps } from 'next/link';
import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

import { LOCALES, DEFAULT_LOCALE } from '@/i18n';

export const routing = defineRouting({
  locales: Object.keys(LOCALES),
  defaultLocale: DEFAULT_LOCALE,
  localeCookie: false, // false for CDN
  localePrefix: {
    mode: 'always',
    // to avoid url redirection when navigating between routes
    prefixes: Object.keys(LOCALES).reduce((acc, locale) => ({ ...acc, [locale]: `/${locale.toLowerCase()}` }), {}),
  },
});

export type Locale = (typeof routing.locales)[number];

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
const { Link: I18nLink, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);

// disable Next prefetch as it doesn't play nicely with CDN
// https://github.com/vercel/next.js/discussions/24437#discussioncomment-3679709
const Link = (props: Omit<LinkProps, 'locale'>) => <I18nLink {...props} prefetch={false} />;

export { Link, redirect, usePathname, useRouter, getPathname };
